import React from "react";
import { Box } from "rebass/styled-components";

import DismissibleNotification from "./DismissibleNotification";
import {
  useComposerState,
  useComposerActions
} from "contextApi/composerContext";
import { useAppState } from "contextApi/appContext";

const ComposerNotifications = () => {
  const inProMode = useComposerState(state => state.inProMode);
  const composerNotifications = useComposerState(
    state => state.composerNotifications
  );
  const removeComposerNotification = useComposerActions(
    actions => actions.removeComposerNotification
  );
  const showWillowAIRevamp = useAppState(state => state.showWillowAIRevamp);

  return (
    <Box
      mb={inProMode || showWillowAIRevamp ? 0 : 12}
      mt={10}
      maxWidth={"550px"}
      data-testid="composer-notifications"
    >
      {composerNotifications.map(notification => (
        <Box key={notification.id} mb={12}>
          <DismissibleNotification
            type={notification.type}
            service={notification.service}
            onDismiss={() => removeComposerNotification(notification.id)}
          >
            {notification.message}
          </DismissibleNotification>
        </Box>
      ))}
    </Box>
  );
};

export default ComposerNotifications;
